import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import useColumnDefinitions from './hooks/useColumnDefinitions';
import useGetDutyCalculationValueSleepDutyTableData from 'components/admin-portal/Tables/CLA/DutyCalculationValueSleepDuty/hooks/useGetDutyCalculationValueSleepDutyTableData';
import CreateEditDutyCalculationValueSleepDuty from 'components/admin-portal/Tables/CLA/DutyCalculationValueSleepDuty/components/form/CreateEditDutyCalculationValueSleepDuty';
import { useTranslation } from 'react-i18next';

const DutyCalculationValueSleepDuty = () => {
  const { t } = useTranslation();
  const columnDefinitions = useColumnDefinitions();
  const { convertedData, isFetching } =
    useGetDutyCalculationValueSleepDutyTableData();

  return (
    <TableCRUDLayout
      canBeDeletedProp="1"
      FormComponent={CreateEditDutyCalculationValueSleepDuty}
      columns={columnDefinitions}
      rows={convertedData}
      loading={isFetching}
      getRowId={(row) => row.dutyCalculationValueSleepDutyId}
      confirmationTitle={t(
        'dutyCalculationValue.sleepDuty.deleteDialog.confirmationTitle'
      )}
      confirmationBody={t(
        'dutyCalculationValue.sleepDuty.deleteDialog.confirmationBody'
      )}
    />
  );
};

export default DutyCalculationValueSleepDuty;
